export default "__VITE_ASSET__BGXL664Q__"